import type {Snapshot} from '@platform/contracts/x';
import {useCopy} from '@platform/ui/config';
import {BottomCta} from './BottomCta';
import {BottomCtaNavigation} from './BottomCtaNavigation';
import {useOwnedCardsMeta} from './useOwnedCardsMeta';
import {isFinished} from './roomFlow';

// Mirror the live footer: back left, quick selection centre, sale counts right.
export function PurchaseReturnCta({state,live,onReturn,onQuick,disabled}:{state:Snapshot;live:Snapshot;onReturn:()=>void;onQuick:()=>void;disabled:boolean}){
 const t=useCopy(),ownedMeta=useOwnedCardsMeta(state),label=t(isFinished(live)?'flow.returnToResults':live.status==='Live'?'flow.returnToLiveDraw':'flow.returnToDraw');
 return <BottomCta className="purchase-panel-footer" revealKey={state.drawId} handleLabel={label} handleMeta={ownedMeta} data-ui="purchase-return-cta">
  <BottomCtaNavigation state={state} onQuick={onQuick} quickLabel={t('room.selectCardsPrompt')} onNavigate={onReturn} navigationLabel={label} back disabled={disabled}/>
 </BottomCta>;
}
